import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import React, { FC, useContext, useEffect } from 'react';
import { LANGUAGES_IMPERIAL_UNITS } from '../../../../constants/commonConstants';
import { ProductSearchResultsContext } from '../../../../context/ProductSearchResultsContext';
import { Button, FilterButtonText } from './FilterButtonStyle';

interface FilterButtonProps {
    activeCategory: string;
    nameOfFilters: string;
    setActiveCategory: Function;
    setIsVisible: Function;
}

const FilterButton: FC<FilterButtonProps> = ({ activeCategory, nameOfFilters, setActiveCategory }) => {
    const { t } = useTranslation();
    const { language } = useI18next();
    const { setCompressionModeUnits } = useContext(ProductSearchResultsContext);

    useEffect(() => {
        if (activeCategory === 'compression_mode') {
            if (LANGUAGES_IMPERIAL_UNITS.indexOf(language) === -1) {
                setCompressionModeUnits('metric');
            } else {
                setCompressionModeUnits('imperial');
            }
        }
    }, [activeCategory]);

    return (
        <Button
            isActive={activeCategory === nameOfFilters}
            onClick={() => {
                setActiveCategory('');
            }}
        >
            <FilterButtonText>{t(nameOfFilters)}</FilterButtonText>
        </Button>
    );
};

export default FilterButton;
